import { BlobServiceClient } from '@azure/storage-blob'
import { BinaryStorageContentDispositionType, BinaryStorageUploadOptions, SasTokenProvider } from '../'
import Env from '../../Env'

export class BlobFileService {
  async upload(
    location: string,
    file: File,
    options: BinaryStorageUploadOptions | undefined = undefined
  ): Promise<void> {
    const sasToken = await new SasTokenProvider().provide({ write: true })
    const serviceClient = new BlobServiceClient(`${Env.AZURE_BLOB_STORAGE_ACCOUNT_URI}/?${sasToken}`)

    const containerClient = serviceClient.getContainerClient(location)
    // API側では呼んでいるが、クライアント側では呼ばない
    // 既にコンテナは作成済みという前提の運用とする。
    // await containerClient.createIfNotExists()

    const blobClient = containerClient.getBlockBlobClient(file.name)
    await blobClient.uploadData(file, {
      blobHTTPHeaders: {
        blobContentType: file.type,
        blobContentDisposition: this.uploadOptionsToContentDisposition(options)
      }
    })
  }

  private uploadOptionsToContentDisposition(options?: BinaryStorageUploadOptions): string | undefined {
    if (options === undefined) return undefined

    const contentDisposition: string[] = []
    switch (options.dispositionType) {
      case BinaryStorageContentDispositionType.Inline: contentDisposition.push('inline'); break
      case BinaryStorageContentDispositionType.Attachment: contentDisposition.push('attachment'); break
      default: contentDisposition.push('inline'); break
    }
    if (options.filenameAlias != null) {
      const encodedAlias = encodeURI(options.filenameAlias)
      contentDisposition.push(`filename="${encodedAlias}"`)
      contentDisposition.push(`filename*=UTF-8''"${encodedAlias}"`)
    }

    return contentDisposition.join('; ')
  }

  async download(location: string, fileName: string): Promise<string> {
    const sasToken = await new SasTokenProvider().provide({ read: true })
    return `${Env.AZURE_BLOB_STORAGE_ACCOUNT_URI}/${location}/${fileName}?${sasToken}`
  }

  async downloadRedirect(location: string, fileName: string): Promise<void> {
    const link = await this.download(location, fileName)
    BlobFileService.downloadRedirectTo(link)
  }

  static downloadRedirectTo(path: string): void {
    // aタグを一時的に生成して、リンククリックをエミュレートすることで、
    // ブラウザの機能により自動的にダウンロードさせる。
    const aTag = document.createElement('a')
    aTag.href = path
    aTag.download = path
    aTag.click()
    aTag.remove()
  }
}
